import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import { Container, BadgesGroup } from './styles';
import Checkbox from '@spa/shared/components/Checkbox';
import { NewFilterLabel } from '@spa/shared/components/Labels/styles';

const FilterCheckbox = ({ name, onChange, icon, label, value, selected = false, isNew = false, helperText }) => {
  const stringifiedValue = value !== undefined && value !== null ? value.toString() : value;
  const { t } = useTranslation('translations');

  return (
    <Container hasHelperText={!!helperText}>
      <Checkbox
        name={name}
        value={stringifiedValue}
        checked={selected}
        onChange={onChange}
        label={label}
        icon={icon}
        helperText={helperText}
      >
        <BadgesGroup>
          {isNew ? <NewFilterLabel className="new">{t('global.labels.new')}</NewFilterLabel> : null}
        </BadgesGroup>
      </Checkbox>
    </Container>
  );
};

FilterCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  icon: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.number, PropTypes.bool]),
  selected: PropTypes.bool,
  isNew: PropTypes.bool,
  helperText: PropTypes.string
};

export default React.memo(FilterCheckbox);
